<template>
    <div class="wrap-question-answer">
        <div class="row">
            <div class="col-md-9 " :class="isEnableWork ? 'wrap-left' : 'wrap-left-modal'">
                <div class="listAnswer">
                    <PreviewQuestion  ref="PreviewQuestion" :id="`question_${0}`" 
                    :dataSource="questionSelect" :location="0"
                    :valCorrectOld="questionSelect.valCorrect"
                    :questions="listQuestion" @getResultQuestion="getResultQuestion"
                    :isDontShowResultSaved="!questionSelect.isWorked" @writedAnswer="writedAnswer" />
                </div>

                <div v-if="questionSelect.isTrue == true || questionSelect.isTrue == false" class="col-md-12">
                    <b-tabs pills>
                        <b-tab @click="changeTab(tabGuide)" title="Hướng dẫn" :active="tabActive == tabGuide">
                            <div v-if="questionSelect.guideContent != ''">
                                <div v-if="questionSelect.isShowAnswer" v-html="questionSelect.guideContent"></div>
                            </div>
                            <div class="margin-top-10 text-center" v-else>
                                Dữ liệu đang được cập nhật
                            </div>
                        </b-tab>
                        <b-tab @click="changeTab(tabAnswer)" title="Lời giải chi tiết" :active="tabActive == tabAnswer">
                            <div v-if="questionSelect.answerDetail != ''">
                                <div v-if="questionSelect.isShowAnswer" v-html="questionSelect.answerDetail"></div>
                            </div>
                            <div class="margin-top-10 text-center" v-else>
                                Dữ liệu đang được cập nhật
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div @click="handleOnChangeQuestion(item)" class="col-md-2 number-question"
                        v-for="(item, index) of lisDataQuestion" :key="index"
                        :class="{ 'is-choose': item.questionId == questionSelect.questionId, 'is-false-number': item.isTrue == false, 'is-true-number': item.isTrue == true }">
                        {{ index + 1 }}
                    </div>

                </div>
                <div v-if="isEnableWork" class="row display-flex justify-content-center">
                    <button :disabled="questionSelect.isTrue == null ? false : true" type="button"
                        @click="handleSubmitQuestion" class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center 
                            justify-content-center line-height-1">
                        Xác nhận
                    </button>
                </div>
            </div>
            <!-- <div class="col-md-12 margin-top-10 text-center">
                <img @click="handlePrevQuestion" class="icon-arrow" src="@/assets/img/arrow-left.png" />
                &nbsp; &nbsp; &nbsp;
                <img @click="handleNextquestion" class="icon-arrow" src="@/assets/img/arrow-right.png" />
            </div> -->

        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

import { saveMemberLearningTaskLesson } from './../_api/memberLearningTaskLessonServices'
import { setContentMediaEditorShow } from './../../question/preview-question-learning-task/_store/helperQuestionContent'
import PreviewQuestion from '@/modules/question/preview-question-excercise-thieu/PreviewQuestion.vue'
import store from '@/modules/question/preview-question-excercise-thieu/_store'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question-excercise-thieu/_store/constants'
export default {
    components: {
       
        PreviewQuestion
    },
    props: {
        listQuestion: {
            type: Array,
            default() {
                return []
            }
        },
        learningTaskId: {
            type: Number,
            default: 0
        },
        isEnableWork: {
            type: Boolean,
            default: true
        },
        isShowAnswer: {
            type: Boolean,
            default: false
        },
    },
    created() {
        if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
            this.$store.registerModule(STORE_KEY_QUESTION, store);
        }
    },
    data() {
        return {
            lisDataQuestion: [],
            questionSelect: {},
            TYPE_RADIO: 'radio',
            TYPE_CHECKBOX: 'checkbox',
            TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
            TYPE_MATH_COL: 'math_col',
            TYPE_FILL_BLANK: 'fill_blank',
            TYPE_FILL_SENTENCE: 'fill_sentence',
            TYPE_SELECT: 'select',
            TYPE_DOWN_ANSWER: 'down_answer',
            TYPE_CIRCLE_ANSWER: 'circle_answer',
            TYPE_X_MARK: 'x_mark_answer',
            TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
            TYPE_GROUP: 'group',
            TYPE_FILL_INPUT_IMG: 'fill_input_img',
            lessonClassSchoolId: 0,
            classSchoolId: 0,
            tabActive: 1,
            tabGuide: 1,
            tabAnswer: 2,
            test: false
        }
    },
    computed:{
        ...mapState('auth', ['loginPopupData']),
        ...mapState('common', ['idBookActiveSuccess', 'setRouterHelp', 'versionApp', 'visiblePreviewSliderModal']),
        ...mapState(STORE_KEY_QUESTION, ['valVituralKeyboard']),
    },
    mounted() {
        if (this.listQuestion && this.listQuestion.length > 0) {
            for (let i = 0; i < this.listQuestion.length; i++) {
                let item = setContentMediaEditorShow(this.listQuestion[i]);
                item.valCorrect = []
                this.lisDataQuestion.push({ ...item, content: setContentMediaEditorShow(item.content), isShowAnswer: false, correct: item.correct ? item.correct : '', isTrue: item.isTrue ? item.isTrue : null, typeUserFill: 1 })
            }
            this.questionSelect = this.lisDataQuestion[0]
            //this.setQuestion(this.questionSelect)
            //console.log(this.questionSelect)
        }
        this.lessonClassSchoolId = this.$route.query.id
        this.classSchoolId = this.$route.query.classSchoolId
    },
    methods: {
        ...mapActions('common', ['setLoading', 'setToggleModalActivePage', 'acSetDataBookActiveWant', 'acToggleModalActiveBook', 'acToggleModaShowHelp', 'actionCheckRouterHelp', 'actionGetVideoHelp', 'acToggleModaShowError', 'actionSetBookIndexId', 'actionSetBookIdForError', 'setActionCheckQuestion', 'actionSetPageNoBook', 'actionCheckExcercise', 'actionCheckInfoExcercise', 'actionCheckPage']),
        ...mapActions('auth', ['setToggleLoginForm']),
        ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),
        changeTab(tab) {
            this.tabActive = tab
        },
        handleOnChangeQuestion(question) {
            this.questionSelect = question
            if (this.isShowAnswer) {
                for (let i = 0; i < this.questionSelect.answers.length; i++) {
                    let element = this.questionSelect.answers[i];
                    element.answerContent = element.correct
                }

                return
            }
        },
        getResultQuestion(data) {
            console.log(data)
            if(data.questionWork.isTrue){
                this.questionSelect.isTrue = true
            }
            else{
                this.questionSelect.isTrue = false
            }
            this.questionSelect.isWorked = true
            //gửi kết quả xuống cho server
            this.senDataUserLearning()
        },
        async checkAnswer() {
            console.log('checkAnswer')
            let self = this;
            self.resetValKeyboard()
            if (self.questionSelect.type !== this.typeDownAnswer) {
                self.setQuestionList4CheckAnswer([{ ...self.questionSelect }])
                self.setQuestionData4CheckAnswer({ ...self.questionSelect })
            }

            if (self.questionSelect.type === this.typeGroup) {
                self.txtMissingQuestionGroup = '';
                self.setQuestionData4CheckAnswer({ ...self.questionSelect, isGroup: true, parent: parent.questionId })
            }

            if (self.questionSelect.type !== this.typeDownAnswer) {
                await self.setActionCheckQuestion(true);
            } else {
                self.questionSelect = { ...self.questionSelect, isTrue: true }
                self.saveQuestion2Local(self.questionSelect)
            }
            //this.questionSelect.isWorked =true
        },
        setResultQuestionsSlider(value = true) {
            if (this.questionindexActive > 0) {
                this.sliderQuestionList[this.questionindexActive - 1]['isWorked'] = true
                this.sliderQuestionList[this.questionindexActive - 1]['isTrue'] = value
            }
            if (this.authInfo && this.authInfo.email === EMAIL_PUBLIC && this.sliderQuestionList.length > 0) {
                this.setResultQuestionForSidebarOfAccFree()
            } else if (this.keySidebarActive === 'info') {
                this.questionIdCheckAnswer = { value, id: this.sliderQuestionList[this.questionindexActive - 1].questionId }
            }
        },
        async setResultQuestionForSidebarOfAccFree() {
            let questionCorrect = 0
            let questionInCorrect = 0
            let questionNotDone = 0
            await this.sliderQuestionList.map(ques => {
                if (ques.isWorked && ques.isTrue) {
                    questionCorrect += 1
                } else if (ques.isWorked && !ques.isTrue) {
                    questionInCorrect += 1
                } else {
                    questionNotDone += 1
                }
            })

            this.questionIdCheckAnswer = { ...this.questionIdCheckAnswer, questionCorrect, questionInCorrect, questionNotDone }
        },
        resetValKeyboard() {
            this.valVituralKeyboard && this.setVituralKeyVal({});
        },
        writedAnswer(data) {
        },
        handleSubmitQuestion() {
            this.checkAnswer()
        },
        senDataUserLearning() {
            let params = {
                lessonClassSchoolId: this.lessonClassSchoolId,
                classSchoolId: this.classSchoolId,
                isTrue: this.questionSelect.isTrue,
                questionId: this.questionSelect.questionId,
                correct: this.questionSelect.correct,
                learningTaskId: this.learningTaskId
            }
            saveMemberLearningTaskLesson(params).then((res) => {

            })
        },

    },
}
</script>
<style lang="scss" scoped>
.justify-content-center {
    justify-content: center;
}

.wrap-left-modal {
    border: 1px solid gray;
    padding: 5px;
    border-radius: 15px;
    min-height: 36rem;
}

.wrap-left {
    border: 1px solid gray;
    padding: 5px;
    border-radius: 15px;
    min-height: 44rem;
}

.justify-content-end {
    justify-content: end;
}

.number-question {
    width: 100%;
    border: 1px solid gray;
    border-radius: 10px;
    margin: 5px;
    cursor: pointer;
    color: black;
}

.is-choose {
    border: 2px solid blue !important;
}

.is-false-number {
    background-color: red;
    color: white !important;
}

.is-true-number {
    background-color: green;
    color: white !important;
}

.is-true {
    color: green;
}

.is-false {
    color: red;
}

.wrap-question-answer {
    background: white;
    border-radius: 8px;
    padding: 1rem;
    height: 100%;
}

.icon-arrow {
    width: 20px;
    height: 30px;
    cursor: pointer;
}

.margin-top-10 {
    margin-top: 10px;
}
</style>
